var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconEdit = function SvgIconEdit(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M1.333 14q-.55 0-.941-.391A1.28 1.28 0 0 1 0 12.667V3.334q0-.55.392-.942Q.783 2 1.333 2h4.35q.335 0 .5.209a.7.7 0 0 1-.008.917q-.175.208-.508.208H1.333v9.333h9.334v-4.35q0-.333.208-.5a.72.72 0 0 1 .917 0q.208.167.208.5v4.35q0 .55-.392.942a1.28 1.28 0 0 1-.941.391zM4 9.334V7.717a1.32 1.32 0 0 1 .383-.933l5.734-5.734q.2-.2.45-.3a1.34 1.34 0 0 1 1.008 0q.241.1.442.3l.933.95q.183.2.283.442.1.241.1.492 0 .25-.091.491a1.25 1.25 0 0 1-.292.442L7.217 9.6q-.184.184-.425.292T6.283 10H4.667a.65.65 0 0 1-.475-.191A.65.65 0 0 1 4 9.334m1.333-.667h.934L10.133 4.8l-.466-.466-.484-.467-3.85 3.85z"
  })));
};
export default SvgIconEdit;